export enum WidgetType{
	CHECKBOX = 'CHECKBOX',
	TEXT = 'TEXT',
	CONTACT_CHOOSER = 'CONTACT_CHOOSER',
	RECIPIENT_CHOOSER = 'RECIPIENT_CHOOSER',
	RADIO_BUTTON = 'RADIO_BUTTON',
	SIMPLE_RADIO_BUTTON = 'SIMPLE_RADIO_BUTTON',
	PRELIMINARY_RISK_ASSESSMENT = 'PRELIMINARY_RISK_ASSESSMENT',
	DATA_RETENTION_AND_DELETION = 'DATA_RETENTION_AND_DELETION',
	TREATMENT_DATA_INTERESTED = 'TREATMENT_DATA_INTERESTED',
	APP_ASSESSMENT = 'APP_ASSESSMENT',
	RISK_ASSESSMENT = 'RISK_ASSESSMENT',
	MULTI_QUESTION = 'MULTI_QUESTION',
	ATTACHMENT = 'ATTACHMENT',
	APP_SUMMARY = 'APP_SUMMARY',
	DPIA = 'DPIA',
	DATE = 'DATE',
	HTML = 'HTML',
}
